/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_V2_Auto_ScrollInputs */

const en_settings_v2_auto_scroll = /** @type {(inputs: Settings_V2_Auto_ScrollInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auto-scroll the reader`)
};

const es_settings_v2_auto_scroll = /** @type {(inputs: Settings_V2_Auto_ScrollInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desplazamiento automático`)
};

/**
* | output |
* | --- |
* | "Auto-scroll the reader" |
*
* @param {Settings_V2_Auto_ScrollInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const settings_v2_auto_scroll = /** @type {((inputs?: Settings_V2_Auto_ScrollInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_V2_Auto_ScrollInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_settings_v2_auto_scroll(inputs)
	return en_settings_v2_auto_scroll(inputs)
});